import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Core as Uppy } from 'uppy';
import _pickBy from 'lodash/pickBy';

import PropelFileUploader from '../../../utils/PropelFileUploader.js';

import { Dashboard } from '@uppy/react';
import classnames from 'classnames';

import Config from '../../graphql/GraphQL.config.js';

import Modal from '../Modals/Modal';
import ProgressButton from '../Buttons/Progress';
import Button from '@material-ui/core/Button';

import combineStyles from '../../../utils/combineStyles';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import SpacingStyles from '../../../styles/helpers/spacing';
import ButtonStyles from '../../../styles/button';
import { allowedFileTypes } from '../../../constants/constants';

import '@uppy/core/dist/style.css';
import '@uppy/drag-drop/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import './uppy.override.css';

const styles = theme => ({
  title: {
    fontWeight: 'bold',
    marginBottom: theme.spacing.unit * 3
  },
  modalFooter: {
    marginTop: `${theme.spacing.unit * 4}px !important`
  },
  cancelButton: {
    marginRight: [8, '!important']
  }
});

export class FileUpload extends Component {
  state = {
    isSubmitting: false,
    dirty: false,
    hasUploaded: false
  };

  constructor(props) {
    super(props);
    this._loadUppy(props.params, props.restrictions);
  }

  _loadUppy = (params = {}, restrictions = {}) => {
    const HTTP = new Config();

    const uppy = Uppy({
      restrictions: {
        allowedFileTypes: [...Object.keys(allowedFileTypes)],
        ...restrictions
      },
      onBeforeUpload: files => {
        return _pickBy(files, file => !file.response);
      }
    });

    uppy.use(PropelFileUploader, {
      endpoint: `${HTTP.getHTTPHost()}/api/FileUpload/`,
      method: 'PUT',
      params,
      headers: {
        ...HTTP.getAuthHeader()
      }
    });

    uppy.on('file-added', () => {
      if (!this.state.dirty) {
        this.setState({ dirty: true });
      }
    });

    uppy.on('file-removed', () => {
      const unprocessedFiles = uppy.getFiles().filter(file => !file.response);
      if (!unprocessedFiles.length) {
        this.setState({ dirty: false });
      }
    });

    this.uppy = uppy;
  };

  componentWillUnmount() {
    this.uppy.close();
  }

  _handleOnSave = async () => {
    this.setState({ isSubmitting: true });
    await this.uppy.upload();
    this.setState({ isSubmitting: false, dirty: false, hasUploaded: true });
  };

  _handleOnClose = () => {
    this.uppy.cancelAll();
    this.props.onClose();
  };

  render() {
    const { classes, t, open } = this.props;
    return (
      <Modal
        open={open}
        onClose={this._handleOnClose}
        classes={{
          footer: classes.modalFooter
        }}
        body={
          <Fragment>
            <h1 className={classnames(classes.headline6, classes.title)}>
              {t('Upload Documents')}
            </h1>
            <Dashboard
              uppy={this.uppy}
              inline={true}
              hideCancelButton={false}
              hideUploadButton={true}
              height={250}
              showLinkToFileUploadResult={false}
              proudlyDisplayPoweredByUppy={false}
            />
          </Fragment>
        }
        footer={
          <Fragment>
            <Button
              color={'primary'}
              className={classnames(classes.button, classes.cancelButton)}
              classes={{
                label: classes.buttonLabel,
                disabled: classes.buttonDisabled
              }}
              disabled={this.state.isSubmitting}
              onClick={this._handleOnClose}
            >
              {!this.state.hasUploaded ? t('Cancel') : t('Close')}
            </Button>

            <ProgressButton
              color={'primary'}
              className={classnames(classes.button)}
              classes={{
                label: classes.buttonLabel,
                disabled: classes.buttonDisabled
              }}
              onClick={this._handleOnSave}
              disabled={!this.state.dirty || this.state.isSubmitting}
              isSubmitting={this.state.isSubmitting}
            >
              {t('Upload')}
            </ProgressButton>
          </Fragment>
        }
      />
    );
  }
}

const FileUploadWithTranslations = withNamespaces()(withApollo(FileUpload));
export default withStyles(
  combineStyles(
    TypographyStyles,
    LayoutStyles,
    SpacingStyles,
    ButtonStyles,
    styles
  )
)(FileUploadWithTranslations);
